<template>
  <div class="clue-count-container">
    <el-form :inline="true" class="demo-form-inline" size="mini">

      <!--<el-form-item>-->
      <!--<el-select placeholder="选择国家" v-model="filter.n_value" @change="fetch_p">-->
      <!--<el-option v-for="item in filter.n_options" :value="item.districtId" :label="item.chinese"></el-option>-->
      <!--</el-select>-->
      <!--<el-select placeholder="选择省/州" v-model="filter.p_value" @change="fetch_c">-->
      <!--<el-option v-for="item in filter.p_options" :value="item.districtId" :label="item.chinese"></el-option>-->
      <!--</el-select>-->
      <!--<el-select placeholder="选择城市" v-model="filter.c_value">-->
      <!--<el-option v-for="item in filter.c_options" :value="item.districtId" :label="item.chinese"></el-option>-->
      <!--</el-select>-->
      <!--</el-form-item>-->

      <el-form-item>
        <el-input v-model="searchServiceName" placeholder="输入类目名查询"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>

    </el-form>
    <el-table :data="data">
      <el-table-column
        prop="serviceTypeId"
        label="ID"
      />
      <el-table-column
        prop="country"
        label="国家"
      />
      <el-table-column
        prop="city"
        label="城市"
      />
      <el-table-column
        prop="serviceTypeName"
        label="二级服务名"
      />
      <el-table-column
        prop="culeCount"
        label="线索卡数量"
      />
      <el-table-column
        label="操作"
      >
        <template slot-scope="scope">
          <el-button type="warning" @click="edit(scope.row.serviceTypeId)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-size="20"
      :current-page.sync="currentPage"
      :total="total"
      ref="pagination"
    >
    </el-pagination>
  </div>
</template>

<script>
  import request from '../request'

  const clueCountUrl = '/service/listServiceWithClue'
  const updateClueCountUrl = '/service/config/update'
  const district_list_url = '/district/listDistrictByParam'

  export default {
    name: '',
    data () {
      return {
        data: [],
        total: 0,
        limit: 20,
        currentPage: 1,
        serviceName: '',
        searchServiceName: '',
        // filter: {
        //   n_options: [],
        //   n_value: '',
        //   p_options: [],
        //   p_value: '',
        //   c_options: [],
        //   c_value: '',
        // },
      }
    },
    methods: {
      async getClueCountList () {
        const params = {
          level: 's',
          start: (this.currentPage - 1) * 20,
          limit: 20,
        }
        if (this.serviceName) {
          params.serviceName = this.serviceName
        }
        const {data: {code, data, pageinfo}} = await request(clueCountUrl, {params})
        if (code === 200) {
          this.data = data
          this.total = pageinfo.totalCount
        }
      },
      // async fetch_n () {
      //   let res = await request.get(district_list_url, {params: {parentId: 0}})
      //   this.loading = false
      //   this.filter.n_options = res.data.data
      // },
      // async fetch_p () {
      //   let res = await request.get(district_list_url, {params: {parentId: this.filter.n_value}})
      //   this.loading = false
      //   this.filter.p_options = res.data.data
      //   this.filter.p_value = ''
      // },
      // async fetch_c () {
      //   let res = await request.get(district_list_url, {params: {parentId: this.filter.p_value}})
      //   this.loading = false
      //   this.filter.c_options = res.data.data
      //   this.filter.c_value = ''
      // },
      async search () {
        this.$refs.pagination.internalCurrentPage = 1
        this.serviceName = this.searchServiceName
        this.getClueCountList()
      },
      async edit (serviceTypeId) {
        try {
          const {value} = await this.$prompt('请输入线索卡数量', '编辑', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValidator (value) {
              return value >= 0 && Number.isInteger(+value)
            },
            inputErrorMessage: '请输入自然数',
          })
          const {data: {code}} = await request.get(updateClueCountUrl, {params: {serviceTypeId, culeCount: value}})
          if (code === 200) {
            this.$message.success('更新线索卡成功')
            this.getClueCountList()
          }
        } catch (e) {
        }
      },
      reset () {
        this.searchServiceName = ''
        this.serviceName = ''
        this.getClueCountList()
      },
    },
    created () {
      this.getClueCountList()
      // this.fetch_n()
    },
    watch: {
      currentPage () {
        this.getClueCountList()
      },
    },
  }
</script>

<style scoped>
  .clue-count-container {

  }
</style>



// WEBPACK FOOTER //
// src/views/clue-count/clue-count.vue